export default "__VITE_ASSET__Bx3TZPcr__"